<template>
  <div v-cloak>
    <div @click="$emit('touch')">
      <div class="flex" v-if="hrConnected == 0">
        <span class="heart connected" ref="hrGlyph" >&hearts;</span>
        <span>HR Connected</span>
      </div>
      <div class="flex" v-else-if="hrConnected == -1">
        <span class="heart signal-lost">&hearts;</span>
        <span>HR Signal Lost</span>
      </div>
      <div class="flex" v-else>
        <span class="heart not-connected">&hearts;</span>
        <span>HR Not connected</span>
      </div>
      <div class="heart-rate" :class="warning">
        <span v-if="heartRate > 10">{{ Math.round(heartRate) }}</span>
        <span v-else>--</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'heartMonitor',
    emits:['touch'],
    props: {
      hrConnected: Number,
      heartRate: Number,
      user: Object,
    },
    data() {
      return {
        pulseTimer:-1
      }
    },
    methods: {
      heartBeat() {
          if (this.heartRate > 10 && this.hrConnected == 0) {
            try {
              this.$refs.hrGlyph.classList.remove("connected");
              this.$refs.hrGlyph.classList.add("black");
              setTimeout(()=> {
                try {
                  this.$refs.hrGlyph.classList.remove("black");
                  this.$refs.hrGlyph.classList.add("connected");
                  clearInterval(this.pulseTimer);
                  this.pulseTimer = setInterval(this.heartBeat, this.pulseInterval);
                }
                catch(err) {
                  clearInterval(this.pulseTimer);
                  this.pulseTimer = -1;  
                }
              }
              ,250); 
            }
            catch(err) {
              clearInterval(this.pulseTimer);
              this.pulseTimer = -1;
            }
          } 
          else {
            if (this.pulseTimer > -1) {
              clearInterval(this.pulseTimer);
              this.pulseTimer = -1;
            }
          }
      }
    },
    computed: {
      warning() {
        if (this.heartRate > this.user.maxHR) {
          return "warning";
        }
        else {
          return "";
        }
      },
      pulseInterval() {
        return (60/this.heartRate)*1000;
      }
    },
    watch: {
      heartRate(newValue, oldValue) {
        if (newValue > 10) {
          if (this.pulseTimer == -1 ) {
            this.heartBeat();
            }
          }
        else {
          clearInterval(this.pulseTimer);
          this.pulseTimer = -1;
        }
      }
    },
    mounted() {
      this.heartBeat();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  p {
    margin:0;
  }
  .heart {
    color:black;
    font-size:2em;
    margin-right:.1em;
    margin-left:.2em;

  }
  .signal-lost {
   color:rgb(52, 123, 255); 
  }

  .connected {
    color:red;
  }

  .not-connected {
    color:grey;
  }

  .heart-rate {
    font-size:20vh;
    line-height:20vh;
  }

  .black {
    color:black;
  }

  .warning {
    background-color:red;
    color:white;
  }

</style>
